import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import "./index.css";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import FilterSearchListing from "Components/FilterSliderComponent/FilterSearchListing";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch } from "Context/CommonContext";
const DivStyled = styled<any>("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  color: #;
  border-bottom: 0.5px solid var(--Grey-20, #eee);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  padding: 12px;
  width: 100%;
  color: ${(props: any) => (!props.selectedFilter ? "#333333" : "#00B0F5")};
`;
const CountSpan = styled<any>("span")`
  color: ${(props: any) => (!props.selectedFilter ? "#333333" : "#00B0F5")};
  padding: 2px;
  font-size: 12px;
  font-weight: 800;
  padding-left: 5px;
`;
const FilterSliderComponent = ({
  isPaneOpen,
  onRequestClose,
  setisPaneOpen,
  filterheadingListing,
  setfilterheadingListing,
  applyFilterHandler,
  addDocumentTypeHandler,
  resetHandler,
  filterState,
}: any) => {
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [selectedFilter, setSelectedFilter] = useState<string>(
    filterheadingListing[0]?.name
  );
  useEffect(() => {
    setSelectedFilter(filterheadingListing[0]?.name);
  }, [isPaneOpen]);
  const handleClearAllFilter = () => {
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    resetHandler && resetHandler();
    ToastDispatch({
      isOpen: true,
      type: "Error",
      message: "All filters reset",
    });
  };
  const disabledHandler = () => {
    if (
      filterheadingListing
        .map((ele: any) => (ele.filterSelectedData.length ? true : false))
        .includes(true)
    ) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <div>
      <Offcanvas
        backdrop={true}
        className="w-100 filterSlider"
        isOpen={isPaneOpen}
        direction="end"
        toggle={onRequestClose}
      >
        <OffcanvasHeader className="filterHeader w-100">
          <div className="d-flex justify-content-between w-100 filterSliderPaneHeaderStyle">
            <div className="d-flex">
              <LeftArrow
                className={"cursorHoverCSS mr-3 ml-1"}
                onClick={() => {
                  setisPaneOpen(!isPaneOpen);
                }}
              />
              <Typography variant={"h6"} color="black">
                Apply Filters
              </Typography>
            </div>
            <div
              className={
                disabledHandler() ? "resetFilter" : "resetFilterEnable"
              }
              onClick={handleClearAllFilter}
            >
              Reset All
            </div>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody className="filterOffcanvasBody">
          <div className="d-flex">
            <div className="filterCol1">
              {filterheadingListing.map((ele: any, index: number) => {
                return (
                  <DivStyled
                    selectedFilter={selectedFilter === ele.name}
                    key={index}
                    className="d-flex justify-content-between"
                    onClick={() => {
                      setSelectedFilter(ele.name);
                    }}
                  >
                    <div>
                      {ele.name}
                      {ele.filterSelectedData.length ? (
                        <CountSpan selectedFilter={selectedFilter === ele.name}>
                          {`(${ele.filterSelectedData.length})`}
                        </CountSpan>
                      ) : null}
                    </div>
                  </DivStyled>
                );
              })}
            </div>
            <div className="filterCol2">
              <FilterSearchListing
                filterheadingListing={filterheadingListing}
                setfilterheadingListing={setfilterheadingListing}
                data={
                  filterheadingListing.find(
                    (ele: any) => ele.name === selectedFilter
                  )?.["data"] || []
                }
                selectedItem={filterheadingListing.find(
                  (ele: any) => ele.name === selectedFilter
                )}
                addDocumentTypeHandler={addDocumentTypeHandler}
              ></FilterSearchListing>
            </div>
          </div>
        </OffcanvasBody>
        <div className="filterFooter">
          <Button
            disabled={disabledHandler()}
            color={disabledHandler() ? "aeslDraft" : "aeslPrimary"}
            className="w-100"
            onClick={() => {
              setisPaneOpen(!isPaneOpen);
              applyFilterHandler(filterState);
            }}
          >
            Apply
          </Button>
        </div>
      </Offcanvas>
    </div>
  );
};
export default FilterSliderComponent;
